import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { isServerSide } from "@jti/fe-common";
import { Toaster } from "@jti/ui/components/Toaster";
import { useTranslations } from "@jti/ui/providers/useTranslations";
import { ConditionalView } from "../../components/conditional-view/ConditionalView";
import { LoadingLayer } from "../../components/loading-layer/LoadingLayer";
import { getUser } from "./getUser";
import { getRedirectionUrl } from "./helpers";
import "./style.scss";
const checkIsAuthor = () => {
    if (isServerSide()) {
        return false;
    }
    return !!window.Granite;
};
const HiddenPageRedirectionLayer = ({ userShouldBeAgeVerified = false, userShouldDeviceBeRegistered, redirectPageForNotAllowedUsers = "", redirectToAuthPage = true, requiredConsentPurposes = [], redirectTime = 3000, }) => {
    const [isLoading, setLoading] = useState(true);
    const isAuthor = checkIsAuthor();
    const { __ } = useTranslations();
    useEffect(() => {
        if (isAuthor) {
            return;
        }
        let timeout;
        (async function () {
            const user = await getUser(requiredConsentPurposes, userShouldBeAgeVerified, userShouldDeviceBeRegistered);
            if (!user?.isLoggedIn || !user.hasUserValidPurposes || !user.isAgeVerified || !user.isDeviceRegistered) {
                toast.success(__("hiddenPage.redirect.label"));
                timeout = window.setTimeout(() => {
                    window.location.href = getRedirectionUrl(redirectPageForNotAllowedUsers, redirectToAuthPage, user?.isLoggedIn);
                }, redirectTime);
                return;
            }
            setLoading(false);
        })();
        return () => {
            if (timeout) {
                clearTimeout(timeout);
            }
        };
    }, []);
    useEffect(() => {
        if (!isLoading) {
            window.document.querySelector(".protectedBodyPage")?.classList.remove("protectedBodyPage");
            window.dispatchEvent(new Event("resize"));
        }
    }, [isLoading]);
    return (_jsxs(_Fragment, { children: [_jsx(LoadingLayer, { transparentBackground: false, isVisible: !isAuthor && isLoading, testId: "hiddenPageLayer" }), _jsx(ConditionalView, { condition: isLoading, children: _jsx(Toaster, {}) })] }));
};
export default HiddenPageRedirectionLayer;
//# sourceMappingURL=HiddenPageRedirectionLayer.js.map